<template>
  <div class="info">
    <div class="info-top">
      <div class="info-top__title">产品供应商信息</div>
      <div class="info-top__right">
        <div class="info-top__name">创建日期:</div>
        <el-date-picker
          v-model="searchData.time"
          size="mini"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"></el-date-picker>
        <el-input size="mini" class="info-top__input" v-model="searchData.text" placeholder="供应商名称/ID/地址/联系人等"></el-input>
        <div class="info-top__btn">搜索</div>
        <div class="info-top__btn" @click="newServiceSupplierBtnClick">新建产品供应商</div>
      </div>
    </div>
    <div class="info-table">
      <Table :head="tableHead" width="1654" height="550"></Table>
    </div>
  </div>
</template>

<script>
import { ProductSupplierInputBoxNewModule, ProductSupplierSearchData } from './class'
import Table from 'components/common/Table.vue'
export default {
  name: 'productSupplierInfo',
  components: {
    Table
  },
  data(){
    return {
      searchData: new ProductSupplierSearchData(),
      tableHead: ProductSupplierInputBoxNewModule.NEWTABLEHEAD()
    }
  },
  methods:{
    /**新建产品供应商 */
    newServiceSupplierBtnClick(){
      this.$emit('go', {
        id: 'newProductSupplier',
        name: '新建产品供应商',
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.info{
  width: 1800px;
  &-top{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 10px 0;
    &__title{
      font-weight: bold;
      font-size: 16px;
      color: black;
    }
    ::v-deep{
      .el-range-separator{
        z-index: 1;
      }
      .el-range-input{
        width: 100px;
      }
      .el-input__inner{
        width: 250px;
      }
      .el-input{
        width: 250px;
        margin: 0 10px;
      }
    }
    &__right{
      display: flex;
      align-items: center;
    }
    &__btn{
      padding: 6px 20px;
      background: #00a0c7;
      color: white;
      margin-left: 5px;
      &:hover{
        cursor: pointer;
        opacity: .8;
      }
    }
  }
}

</style>
